import { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import CustomerStatus from './pages/CustomerStatus';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import RepairDetail from './pages/RepairDetail';
import NewRepair from './pages/NewRepair';
import Search from './pages/Search';

function App() {
  const [token, setToken] = useState(sessionStorage.getItem('idToken'));

  const handleLogin = (idToken, refreshToken) => {
    sessionStorage.setItem('idToken', idToken);
    if (refreshToken) sessionStorage.setItem('refreshToken', refreshToken);
    setToken(idToken);
  };

  const handleLogout = () => {
    sessionStorage.removeItem('idToken');
    sessionStorage.removeItem('refreshToken');
    setToken(null);
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<CustomerStatus />} />
        <Route
          path="/admin/login"
          element={token ? <Navigate to="/admin" replace /> : <Login onLogin={handleLogin} />}
        />
        <Route
          path="/admin"
          element={token
            ? <Dashboard token={token} onLogout={handleLogout} />
            : <Navigate to="/admin/login" replace />}
        />
        <Route
          path="/admin/repairs/new"
          element={token
            ? <NewRepair token={token} onLogout={handleLogout} />
            : <Navigate to="/admin/login" replace />}
        />
        <Route
          path="/admin/repairs/:repair_number"
          element={token
            ? <RepairDetail token={token} onLogout={handleLogout} />
            : <Navigate to="/admin/login" replace />}
        />
        <Route
          path="/admin/search"
          element={token
            ? <Search token={token} onLogout={handleLogout} />
            : <Navigate to="/admin/login" replace />}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;